"use client";
import { Paper } from "@mantine/core";
import "@mantine/core/styles/Paper.layer.css";
Paper.displayName = "Paper";
export { Paper };
//# sourceMappingURL=Paper.js.map